import * as React from 'react';
import { IMenuConfig } from './MenuConfig';

const MenuConfigContext = React.createContext<IMenuConfig>({
  menuItems: [],
});

export default MenuConfigContext;
